import React, {useContext, useEffect} from "react";
import PropTypes from 'prop-types';
import SocketContext from "../../../../Services/Socket/SocketContext";
const WebSocket = (props) => {
    const {connect, disconnect} = useContext(SocketContext)
    useEffect(() => {
        connect(props.doActions)
        return () => {
            //remove interval on unmount
            disconnect();
        }
    }, [])

    return <></>
}

WebSocket.propTypes = {
    component: PropTypes.object,
    doActions: PropTypes.func
}

export default WebSocket;